<template>
  <div class="container">
    <div class="dashboard-calendar__title-container">
      <base-more-details-link class="dashboard-calendar__link" to="/calendar"/>
    </div>
    <div class="dashboard-calendar__loader" v-if="dataFetchingCount !== 0">
      <base-loader/>
    </div>
    <div class="dashboard-calendar__week" v-else-if="events.length > 0">
      <div class="dashboard-calendar__day-container" v-for="day in events" :key="selectedClient._id + day.date">
        <div class="dashboard-calendar__date">{{getDateTitle(day.date)}}</div>
        <dashboard-day :events="day.events" :date="day.date"></dashboard-day>
      </div>
    </div>
    <div v-if="isDataMissing" class="dashboard-calendar__awaiting no-data-block">Awaiting Data</div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import DashboardDay from './DashboardDay'
import moment from 'moment'
/**
 * It's component that is absent in final version of the application.
 * This one may be in demand in the future
 */
export default {
  name: 'DashboardCalendar',
  components: { DashboardDay },
  created () {
    if (this.selectedClient) {
      this.loadData()
    }
  },
  data: function () {
    return {
      dataFetchingCount: null,
      days: []
    }
  },
  watch: {
    selectedClient () {
      this.loadData()
    }
  },
  computed: {
    ...mapState({
      selectedClient: 'selectedClient'
    }),
    ...mapState('dashboard', [ 'events' ]),
    isDataMissing () {
      return this.dataFetchingCount === 0 && this.events.length === 0
    }
  },
  methods: {
    ...mapActions('dashboard', [
      'getCalendar', 'resetData'
    ]),

    loadData: async function () {
      if (this.dataFetchingCount === null) {
        this.dataFetchingCount = 0
      }
      this.dataFetchingCount++
      await this.getCalendar({ clientId: this.clientId })
      this.dataFetchingCount--
    },

    getDateTitle (date) {
      return moment(date).format('MMM, DD')
    }
  }
}
</script>

<style lang="scss" scoped>

  .dashboard-calendar {
    &__event {
      color: #d88b23;
      background-color: rgba(255, 166, 40, 0.1);

      &:hover {
        color: #d88b23;
      }
    }

    &__brief {
      color: #284aff;
      background-color: rgba(40, 74, 255, 0.1);

      &:hover {
        color: #284aff;
      }
    }

    &__cell {
      &_disabled {
        cursor: default !important;
      }
    }

    &__loader {
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;
      height: 160px;
    }

    &__day-container {
      flex: 0 1 200px;
      &:not(:first-child) {
        margin-left: 10px;
      }
    }

    &__date {
      font-size: 12px;
      color: $rfx-dark-march;
      opacity: 0.5;
      margin-bottom: 10px;
    }

    &__week {
      display: flex;
    }

    &__title-container {
      display: flex;
      justify-content: space-between;
    }

    &__link {
      pointer-events: none;
    }

  }

</style>
